import { inject as i, computed as n } from "vue";
import { configProviderInjectionKey as d } from "./ghl-ui.es984.js";
import u from "./ghl-ui.es750.js";
import c from "./ghl-ui.es751.js";
function R(t) {
  const {
    mergedLocaleRef: o,
    mergedDateLocaleRef: l
  } = i(d, null) || {}, a = n(() => {
    var e, r;
    return (r = (e = o == null ? void 0 : o.value) === null || e === void 0 ? void 0 : e[t]) !== null && r !== void 0 ? r : u[t];
  });
  return {
    dateLocaleRef: n(() => {
      var e;
      return (e = l == null ? void 0 : l.value) !== null && e !== void 0 ? e : c;
    }),
    localeRef: a
  };
}
export {
  R as default
};
